import { useStores } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { AgentAvatar } from './agents-avatar';
import { readAgentActivity } from './agents.hooks';
import { agentsStore } from './agents.store';

export const AgentsTabIcon = observer(({ chatId }: { chatId: string }) => {
  const stores = useStores();
  const agent = agentsStore.getByChatId(chatId);
  if (!agent) return null;
  const { activity } = readAgentActivity(stores, {
    agentId: agent.agentId,
    chatId,
    introPending: !agent.description,
    active: true,
  });
  return (
    <AgentAvatar bird={agent.bird} activity={activity} className="size-4" />
  );
});
